import React,{useState,useEffect} from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Navigate } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import { useTranslation } from 'react-i18next';
import constants from '../../common/constants';

const CustomModal = (props) =>{
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    const operator = localStorage.getItem('currentOperator');
    const onlyCountries = operator === 'ASIACELL_IRAQ' ? ['iq'] : undefined;

    const modalStyle = {
        display: props.showModal ? 'block' : 'none',
    };

    const user_id =props.user_id;
    
    const hostname = window.location.hostname.split('.')[0];
    const [phonevalue,setphonevalue] = useState('');
    const country = (hostname === 'ae') ? 'ae' : (constants.Operators[operator]?.COUNTRY || 'us');
    const [phonevisible,setphonevisible] = useState(true);
    const [otp,setOTP] = useState('');
    const [otpvisible,setotpvisible] = useState(false)
    const [msg,setMsg] = useState('');
    // const [thankyou,setThankyou]=useState(false);

    const getRandomInteger = (min, max) => {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
      };

    const isPhoneNumberComplete = (phoneNumber) => {
        return phoneNumber && phoneNumber.length >= 11; 
    };

    const isOtpComplete = (otp) =>{
        return otp === "8090";
    };
  

    const handleSubscribe = () =>{
        setMsg('');
        if(isPhoneNumberComplete(phonevalue)){
            setphonevisible(false);
            setotpvisible(true);
        }else{
        setMsg('incorrect');
        }
    }

    const handleOTP = () =>{
        setMsg('');
        if(isOtpComplete(otp)){
            setotpvisible(false);
            // setThankyou(true);
            
            const randomInteger = getRandomInteger(1, 1000);
            localStorage.setItem("user_public_id", randomInteger);
            props.setUserId(localStorage.getItem("user_public_id"));
            if(props.categoryId && props.categoryCode){
                window.location.href = `../content/${props.categoryId}?code=${props.categoryCode}`;
            }else if(props.ibwpage){
                window.location.href = `../ibw`;
            }else if(props.chatbotpage){
                window.location.href = `../chatbot`;
            }
            props.handleClose(); 
        }else{
         setMsg('incorrect');
        }

    }

    const handleCloseSub = ()=>{
        setphonevisible(true);
        setotpvisible(false);
        // setThankyou(false);

        setphonevalue('');
        setOTP('');
        setMsg('');
        props.handleClose();   
    };
    
    return(
        <div className="modal" tabIndex="-1" role="dialog" style={modalStyle}>
            <div className="modal-dialog modal-dialog-centered" role="document">
                {!user_id && (
                    <>
                    {phonevisible && (
                        <div className="modal-content">
                            <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>
                            <button type="button" className="btn-close" onClick={handleCloseSub} aria-label="Close"></button>
                            </div>
                            <div className="modal-body ">
                                < img src="../assets/images/logo.png" width="150px" height="150px" className="img-fluid" />
                                <label className={`pt-3 pb-3 text-light ${isArabic ? 'notokufi-regular' : 'avenir-reagular'}`}>{t('custommodal.phonelabel')}</label>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <PhoneInput placeholder="Enter phone number" className="" value={phonevalue} onChange={(phone) => setphonevalue(phone)} country={country} onlyCountries={onlyCountries}/>
                                    {msg && <p className={`pt-1  ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} style={{ color: 'red' }}>{t(msg)}</p>}
                                    <button type="button" className={`btn btn-sub  ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`} onClick={handleSubscribe}>{t('custommodal.Subscribe')}</button>
                                </div>
                                <div className={`small text-light pt-4 ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`}>{t('custommodal.not_subscriber')}</div>
                            </div>
                        </div>
                    )}
                    {otpvisible && (
                        <div className="modal-content">
                            <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>
                            <button type="button" className="btn-close" onClick={handleCloseSub} aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <img src="../assets/images/logo.png" width="150px" height="150px" className="img-fluid" />
                                <label className={`pt-3 pb-3 text-light  ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`}>{t('custommodal.otplabel')}</label>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',direction:"ltr" }} >
                                <OtpInput 
                                    value={otp} 
                                    onChange={setOTP} 
                                    numInputs={4} 
                                    renderSeparator={<span>-</span>} 
                                    renderInput={(props, index) => (
                                        <input 
                                        {...props} 
                                        autoFocus={index === 0}
                                        inputMode="tel"
                                        style={{ width: '40px', height: '40px', textAlign: "center" }}
                                        onKeyPress={(e) => {
                                            const charCode = e.which ? e.which : e.keyCode;
                                            // Allow only numeric characters (0-9) by checking ASCII codes
                                            if (charCode < 48 || charCode > 57) {
                                            e.preventDefault();
                                            }
                                        }}
                                        />
                                    )} 
                                    />
                                    {msg && <p className={`pt-1 ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} style={{ color: 'red' }}>{t(msg)}</p>}
                                    <button type="button" className={`btn btn-sub ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`} onClick={handleOTP}>{t('custommodal.Verify')}</button>
                                </div>
                                <div className={`small text-light pt-4  ${isArabic ? 'notokufi-regular' : 'avenir-reagular'}`}>{t('custommodal.not_subscriber')}</div>
                            </div>
                        </div>
                    )}
                    {/* {thankyou  && (
                        <div className="modal-content">
                            <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>
                            <button type="button" className="btn-close" onClick={handleCloseSub} aria-label="Close"></button>
                            </div>
                            <div className="modal-body poppins-medium">
                                < img src="../assets/images/logo.png" width="150px" height="150px" className="img-fluid" />
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                                  <h1 className='thank-you mt-4 avenir-heavy'>Thank You !</h1>
                                  <a href="/" className='go-back text-center pt-1 avenir-book'>Go Back</a>
                                </div>
                            </div>
                        </div>
                    )}*/}
                    </> 
                )}
            </div>
        </div>
    );
};

export default CustomModal;